// extracted by mini-css-extract-plugin
export default {"tooltip":"Sx-z","arrow":"Tx-z"};